const SortingService = {
    getAllForUnits: () => {
        return [
            {
                field: 'fields.street',
                direction: 'asc',
                label: 'tx_zigrealestate.list.sort_address_asc',
            },
            {
                field: 'fields.street',
                direction: 'desc',
                label: 'tx_zigrealestate.list.sort_address_desc',
            },
            {
                field: 'fields.crdate',
                direction: 'desc',
                label: 'tx_zigrealestate.list.sort_date_desc',
            },
            {
                field: 'fields.price',
                direction: 'asc',
                label: 'tx_zigrealestate.list.sort_price_asc',
            },
            {
                field: 'fields.price',
                direction: 'desc',
                label: 'tx_zigrealestate.list.sort_price_desc',
            },
        ];
    },
    getAllForComplexes() {
        return [
            {
                field: 'fields.name',
                direction: 'asc',
                label: 'tx_zigrealestate.list.complex_name_asc',
            },
            {
                field: 'fields.name',
                direction: 'desc',
                label: 'tx_zigrealestate.list.complex_name_desc',
            },
        ];
    },
};
export default SortingService;
